import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatForeignDefaultInfoUnitDetail,
	formatForeignDomesticUnitList,
} from './foreign-default-info-unit.helper';
import { OI1_01DefaultInfoUnitActions } from './foreign-default-info-unit.redux';
import {
	TPayloadGetForeignDefaultInfoUnitDetailRequest,
	TPayloadGetForeignDomesticUnitListRequest,
} from './foreign-default-info-unit.type';

export function* getForeignDefaultInfoUnitDetail(
	action: PayloadAction<TPayloadGetForeignDefaultInfoUnitDetailRequest>
) {
	const { callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetForeignDefaultInfoUnitResponse> =
			yield API.getForeignUnitBasicInfo();
		const defaultInfoUnitDetail = formatForeignDefaultInfoUnitDetail(res?.data);
		yield put(
			OI1_01DefaultInfoUnitActions.getForeignDefaultInfoUnitDetailSuccess({
				defaultInfoUnitDetail,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(OI1_01DefaultInfoUnitActions.getForeignDomesticUnitListFailure());
	}
}

export function* getForeignDomesticUnitList(
	action: PayloadAction<TPayloadGetForeignDomesticUnitListRequest>
) {
	const { callback, allData = false } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetForeignDomesticUnitListResponse> =
			yield API.getForeignDomesticUnitList(allData);
		const domesticUnitList = formatForeignDomesticUnitList(res?.data?.content);
		yield put(
			OI1_01DefaultInfoUnitActions.getForeignDomesticUnitListSuccess({
				domesticUnitList,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(OI1_01DefaultInfoUnitActions.getForeignDomesticUnitListFailure());
	}
}
